/** Returns ms value from css variable. */
export function parseDuration(d: string): number {
  const groups = d
    .trim()
    .match(/^((?<miliseconds>[0-9]+)ms)|((?<seconds>[0-9]+)s)$/)?.groups;
  if (groups?.["miliseconds"]) {
    return Number(groups?.["miliseconds"]);
  }
  if (groups?.["seconds"]) {
    return Number(groups?.["seconds"]) * 1000;
  }
  return 0;
}
